import PropTypes from 'prop-types';

const stageCategoriesDataPropTypes = PropTypes.shape({
    firstStageCategories: PropTypes.array,
    secondStageCategories: PropTypes.array,
    firstStageCategoriesLoading: PropTypes.bool,
    secondStageCategoriesLoading: PropTypes.bool,
    firstStageCategoryValue: PropTypes.any,
    secondStageCategoryValue: PropTypes.any,
    fetchFirstStageCategories: PropTypes.func,
    fetchSecondStageCategories: PropTypes.func,
    setFirstStageCategories: PropTypes.func,
    setFirstStageCategoriesLoading: PropTypes.func,
    setSecondStageCategoriesLoading: PropTypes.func,
    reset: PropTypes.func,
    resetToFirstCategory: PropTypes.func,
});

export default stageCategoriesDataPropTypes;
